interface TierTheme {
    gradient: string;
    accent: string;
    icon: string;
}

const TIER_THEMES: Record<string, TierTheme> = {
    bronze: {
        gradient: "from-amber-900/20 via-orange-800/10 to-yellow-900/5",
        accent: "var(--amber-700, #b45309)",
        icon: "🥉",
    },
    silver: {
        gradient: "from-slate-400/20 via-gray-300/10 to-slate-200/5",
        accent: "var(--slate-500, #64748b)",
        icon: "🥈",
    },
    gold: {
        gradient: "from-yellow-500/20 via-amber-400/10 to-yellow-300/5",
        accent: "var(--yellow-600, #ca8a04)",
        icon: "🥇",
    },
    platinum: {
        gradient: "from-cyan-400/20 via-sky-300/10 to-blue-200/5",
        accent: "var(--cyan-600, #0891b2)",
        icon: "💎",
    },
    diamond: {
        gradient: "from-violet-500/20 via-purple-400/10 to-fuchsia-300/5",
        accent: "var(--violet-600, #7c3aed)",
        icon: "👑",
    },
};

const DEFAULT_THEME: TierTheme = {
    gradient: "from-primary/20 via-primary/10 to-primary/5",
    accent: "var(--primary)",
    icon: "⭐",
};

export function getTierTheme(tierId: string | null | undefined): TierTheme {
    if (!tierId) return DEFAULT_THEME;
    const normalized = tierId.toLowerCase().trim();
    return TIER_THEMES[normalized] ?? DEFAULT_THEME;
}
